<!-- =========================================================================================
    File Name: ProductSaleStatistics.vue
    Description: Sales by product
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vx-card title="Ventas por producto" class="m-1">
        <div class="flex justify-start inline-block align-middle">
          <div class="mr-2" style="min-width: 495px;">
            <ejs-daterangepicker ref="period" :startDate="startDate" :endDate="endDate" floatLabelType="Auto" placeholder="Seleccione período"/>
          </div>
          <div>
            <vs-button radius color="success" type="filled" icon-pack="feather" icon="icon-search" class="ml-4 mt-2" @click="getData"/>
          </div>
        </div>
      </vx-card>
      <vx-card class="m-1" v-show="gridReady">
        <ejs-tab ref="tabs">
          <div class="e-tab-header">
            <div>Tabla</div>
            <div>Lista</div>
          </div>
          <div class="e-content">
            <div>
              <vs-button size="small" color="success" type="flat" @click="excelExport">Exportar a Excel</vs-button>
              <ejs-pivotview
                ref="pivot"
                :dataSourceSettings="dataSourceSettings"
                :dataBound="dataBound"
                :showGroupingBar="false"
                showFieldList=true
                locale='es-GT'
                allowExcelExport=true
                height="500"
                :gridSettings="gridSettings"
              />
            </div>
            <div>
              <ejs-grid
                ref="grid"
                id="grid"
                :dataSource="data"
                locale='es-GT'
                :toolbar='toolbarOptions'
                :allowPaging="true"
                :pageSettings='pageSettings'
                :allowSorting='true'
                :sortSettings='sortOptions'
                :allowExcelExport='true'
                :allowGrouping='true'
                :toolbarClick='toolbarClick'
                :allowFiltering='true'
                :filterSettings='filterOptions'
              >
                <e-columns>
                  <e-column field='ISBN' width="160"/>
                  <e-column field='Descripción' clipMode='EllipsisWithTooltip' width="400"/>
                  <e-column field='Fecha' width="180"/>
                  <e-column field='Orden No.' type="number" textAlign='Right' format="N0" width="130"/>
                  <e-column field="quantity" headerText='Cantidad' type="number" textAlign='Right' format="N2" width="130"/>
                  <e-column field='Subtotal' type="number" textAlign='Right' format="N2" width="130"/>
                  <e-column field='Descuento' type="number" textAlign='Right' format="N2" width="140"/>
                  <e-column field='Total' type="number" textAlign='Right' format="N2" width="130"/>
                  <e-column field='IVA' type="number" textAlign='Right' format="N2" width="130"/>
                  <e-column field="netAmount" headerText='Total sin IVA' type="number" textAlign='Right' format="N2" width="160"/>
                  <e-column field='Cupón' width="150" :filter='checkBoxFilter'/>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
        </ejs-tab>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport, Group, Filter} from '@syncfusion/ej2-vue-grids';
import {AutoComplete} from '@syncfusion/ej2-dropdowns';
import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
import {DateRangePickerPlugin} from '@syncfusion/ej2-vue-calendars';
import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
import numbers from 'cldr-data/main/es-GT/numbers.json';
import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import {PivotViewPlugin, GroupingBar, FieldList, CalculatedField} from '@syncfusion/ej2-vue-pivotview';
import {TabPlugin} from '@syncfusion/ej2-vue-navigations';
import {db} from '@/firebaseConfig';
// import * as admin from 'firebase-admin';

Vue.use(GridPlugin, AutoComplete);
Vue.use(DropDownListPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(PivotViewPlugin);
Vue.use(TabPlugin);

loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
setCulture('es-GT');
L10n.load({
  'es-GT': {
    'daterangepicker': {
      placeholder: 'Seleccione período',
      startLabel: 'Fecha inicial',
      endLabel: 'Fecha final',
      applyText: 'Seleccionar',
      cancelText: 'Cancelar',
      selectedDays: 'Seleccione día inicial y final',
      days: 'Días'
    },
    'pivotview': {
      'grandTotal': 'Gran total',
      'total': 'Total',
      'value': 'Valor',
      'noValue': 'Sin valor',
      'row': 'Fila',
      'column': 'Columna',
      'collapse': 'Colapsar',
      'expand': 'Expandir',
      'rowAxisPrompt': 'Arrastre fila aquí',
      'columnAxisPrompt': 'Arrastre columna aquí',
      'valueAxisPrompt': 'Arrastre valor aquí',
      'filterAxisPrompt': 'Arrastre filtro aquí',
      'filter': 'Filtro',
      'filtered': 'Filtrado',
      'sort': 'Ordenar',
      'filters': 'Filtros',
      'rows': 'Filas',
      'columns': 'Columnas',
      'values': 'Valores',
      'close': 'Cerrar',
      'cancel': 'Cancelar',
      'delete': 'Eliminar',
      'calculatedField': 'Campo calculado',
      'sum': 'Suma'
    },
    "pivotfieldlist": {
      'fieldList': 'Lista de campos',
      'dropRowPrompt': 'Arrastre fila aquí',
      'dropColPrompt': 'Arrastre columna aquí',
      'dropValPrompt': 'Arrastre valor aquí',
      'dropFilterPrompt': 'Arrastre fo;trp aquí',
      'addPrompt': 'Agregar campo',
      'centerHeader': 'Centrar encabezado:',
      'add': 'Agregar',
      'drag': 'Arrastrar',
      'filters': 'Filtros',
      'rows': 'Filas',
      'columns': 'Columnas',
      'values': 'Valores',
      'error': 'Error',
      'dropAction': 'El campo calculado no puede estar en otra región excepto el valor en eje.',
      'search': 'Buscar',
      'close': 'Cerrar',
      'cancel': 'Cancelar',
      'delete': 'Eliminar',
      'alert': 'Alerta',
      'warning': 'Advertencia',
      'ok': 'Aceptar',
      'allFields': 'Todos los campos',
      'noMatches': 'Sin coincidencias'
    },
    'grid': {
      'EmptyRecord': 'No se encontraron datos',
      'Search': 'Buscar',
      'Excelexport': 'Exportar',
      'GroupDropArea': 'Arrastre un encabezado de columna aquí para agrupar por esa columna'
    },
    'pager': {
      'currentPageInfo': '{0} de {1} páginas',
      'firstPageTooltip': 'Ir a primera página',
      'lastPageTooltip': 'Ir a última página',
      'nextPageTooltip': 'Ir a página siguiente',
      'previousPageTooltip': 'Ir a página anterior'
    }
  }
});

export default {
  data() {
    return {
      dataSourceSettings: {
        dataSource: this.data,
        expandAll: false,
        columns: [{name: 'year', caption: 'Año'}, {name: 'month', caption: 'Mes'}, {name: 'week', caption: 'Semana'}],
        values: [{name: 'quantity', caption: 'Cantidad'}, {name: 'netAmount', caption: 'Total sin IVA'}],
        rows: [{name: 'fullDescription', caption: 'Descripción completa'}],
        formatSettings: [
          {name: 'quantity', format: 'N0'},
          {name: 'netAmount', format: 'N2'}
        ],
        filters: []
      },
      gridSettings: {
        columnWidth: 80,
        clipMode: 'EllipsisWithTooltip'
      },
      mounted: false,
      gridReady: false,
      allowFiltering: true,
      startDate: null,
      endDate: null,
      dateFormatOptions: {type: 'dateTime', format: 'dd/MM/yyyy hh:mm a'},
      cardTitle: 'Venta por producto',
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: {pageSize: 25},
      sortOptions: {columns: [{field: 'Fecha', direction: 'Ascending'}, {field: 'ISBN', direction: 'Ascending'}]},
      data: [],
      filterOptions: {
        type: 'Menu'
      },
      checkBoxFilter: {
        type: 'CheckBox'
      },
      journalFilter: {
        type: 'CheckBox'
      }
    }
  },
  provide: {
    grid: [Toolbar, Search, Page, Sort, ExcelExport, Group, Filter],
    pivotview: [GroupingBar, FieldList, CalculatedField]
  },
  methods: {
    formatDate: function (date) {
      const d = date.toDate();
      return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    },
    getWeek(date) {
      const first = new Date(date.getFullYear(), 0, 1);
      const pastDays = (date - first) / 86400000;
      return Math.ceil((pastDays + first.getDay() + 1) / 7);
    },
    dateISOFormat(value) {
      const d = new Date(value.getTime() - (6 * 60 * 60 * 1000));
      return d.toISOString();
    },
    toolbarClick: function (args) {
      if (args.item.id === 'grid_excelexport') {
        this.$refs.grid.excelExport({fileName: `Ventas por producto.xlsx`});
      }
    },
    excelExport() {
      const pivot = this.$refs.pivot.ej2Instances;
      pivot.excelExport();
    },
    getData() {
      this.$refs.tabs.select(0);
      this.startDate = this.$refs.period.getSelectedRange().startDate;
      this.endDate = this.$refs.period.getSelectedRange().endDate;
      if (this.startDate) {
        if (this.endDate) {
          this.startDate.setHours(0);
          this.startDate.setMinutes(0);
          this.startDate.setSeconds(0);
          this.endDate.setHours(23);
          this.endDate.setMinutes(59);
          this.endDate.setSeconds(59);
          if (this.startDate < this.endDate) {
            /*
                          const startDate = admin.firestore.Timestamp.fromDate(this.startDate);
                          const endDate = admin.firestore.Timestamp.fromDate(this.endDate);
            */
            this.cardTitle = `Venta por producto del ${this.startDate.toLocaleDateString()} al ${this.endDate.toLocaleDateString()}`;
            this.$vs.loading({
              text: 'Cargando consulta',
              type: 'point'
            });
            this.data = [];
            const self = this;
            db.collection('orders')
              .where('date', '>=', this.startDate)
              .where('date', '<=', this.endDate)
              .get()
              .then(querySnapshot => {
                const data = querySnapshot.docs.map(doc => doc.data());
                let j = 0;
                let discount = 0;
                let total = 0;
                let net = 0;
                let vat = 0;
                let coupon = '';
                for (let i = 0; i < data.length; i++) {
                  for (j = 0; j < data[i].products.length; j++) {
                    if (data[i].hasOwnProperty('discountPercent')) {
                      if (data[i].discountPercent > 0) {
                        discount = Math.round(data[i].products[j].amount * data[i].discountPercent) / 100;
                      } else {
                        discount = 0;
                      }
                    } else {
                      discount = 0
                    }
                    if (data[i].hasOwnProperty('couponCode')) {
                      coupon = data[i].couponCode;
                    } else {
                      coupon =  ''
                    }
                    total = data[i].products[j].amount - discount;
                    net = Math.round(total / 1.12 * 100) / 100;
                    vat = total - net;
                    self.data.push({
                      'ISBN': data[i].products[j].isbn,
                      'Descripción': data[i].products[j].description,
                      'fullDescription': `${data[i].products[j].isbn} - ${data[i].products[j].description}`,
                      'Fecha': self.formatDate(data[i].date),
                      'year': data[i].date.toDate().getFullYear(),
                      'month': data[i].date.toDate().getMonth() + 1,
                      'week': self.getWeek(data[i].date.toDate()),
                      'Orden No.': data[i].id,
                      'quantity': data[i].products[j].quantity,
                      'Subtotal': data[i].products[j].amount,
                      'Descuento': discount,
                      'Total': total,
                      'IVA': vat,
                      'netAmount': net,
                      'Cupón': coupon
                    })
                  }
                }
                self.$refs.pivot.ej2Instances.dataSourceSettings.dataSource = self.data;
                self.gridReady = true;
                self.loaded = true;
                self.$vs.loading.close();
              })
              .catch((error) => {
                self.$vs.notify({
                  title: 'Error al cargar listado de órdenes',
                  text: error.message,
                  color: 'danger'
                });
                self.$vs.loading.close();
              });
          }
        }
      }
    },
    dataBound() {
      this.$vs.loading.close();
    },
    refreshData(card) {
      this.getData();
      if (typeof card !== 'undefined') {
        card.removeRefreshAnimation(500);
      }
    }
  }
}

</script>

<style lang="scss">
@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-grids/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-pivotview/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css";
</style>
